import { render } from "./SystemAdmin.vue?vue&type=template&id=4b03f5dd"
import script from "./SystemAdmin.vue?vue&type=script&lang=js"
export * from "./SystemAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__